import { t } from "../i18n/index.ts";
import type { ListView } from "../lib/cardView.ts";
import { Segmented } from "./Segmented.tsx";

/** Table, cards or board. */
export function ViewToggle(p: { views: readonly ListView[]; view: ListView; onView: (v: ListView) => void }) {
  return (
    <Segmented
      label={t("items.view.label")}
      size="md"
      class="ml-auto"
      value={p.view}
      onValue={p.onView}
      options={p.views.map((v) => ({ value: v, label: t(`items.view.${v}`) }))}
    />
  );
}
